import { useContext } from "react";
import BeelditTableHeaderActions from "@beeldit/core/components/BeelditTableHeaderActions";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { t } from "i18next";

import { Card } from "react-bootstrap";
import useCreateAction from "@beeldit/core/actions/create/useCreateAction";
import useRemoveAction from "@beeldit/core/actions/remove/useRemoveAction";
import { getTableConfig } from "@beeldit/core/helpers/tables";
import useListAction from "../actions/calendar/useListAction";
import useInitialize from "@beeldit/core/actions/create/useInitialize";
import useCancelAction from "../actions/cancel/useCancelAction";
import useUncancelAction from "../actions/uncancel/useUncancelAction";
import useEditAction from "../actions/edit/useEditAction";
import useGet from "../actions/edit/useGet";

function CalendarPage(props: { modelConfig: any }) {
  const { modelConfig } = props;
  const { user } = useContext(AuthContext);

  const initialize = useInitialize();
  const initializeFunction = (initializeData: any) =>
    initialize(initializeData);

  const get = useGet(modelConfig);
  const getFunction = (id: number) => get(id);

  const {
    indexFunction,
    actionTemplate: listActionTemplate,
    setTableConfig,
  } = useListAction(modelConfig, user, {}, initializeFunction, getFunction);

  const { actionTemplate: createActionTemplate, showModal: creationShowModal } =
    useCreateAction(modelConfig, indexFunction);

  const { prepareCancelFunction, actionTemplate: cancelActionTemplate } =
    useCancelAction(modelConfig, indexFunction);

  const { prepareUncancelFunction, actionTemplate: uncancelActionTemplate } =
    useUncancelAction(modelConfig, indexFunction);

  const { actionTemplate: editActionTemplate, showModal: editShowModal } =
    useEditAction(
      modelConfig,
      indexFunction,
      prepareCancelFunction,
      prepareUncancelFunction
    );

  const { prepareRemoveFunction, actionTemplate: removeActionTemplate } =
    useRemoveAction(modelConfig, indexFunction);

  /**<newActionsHooks**/

  /**
   * Table configuration definition
   */
  let tableConfig = getTableConfig(modelConfig.tableConfig, {
    indexFunction: indexFunction,
    actionsFunctions: [
      {
        name: "create",
        function: initializeFunction,
      },
    ],
    rowFunctions: [
      {
        name: "edit",
        function: getFunction,
      },
      {
        name: "delete",
        function: prepareRemoveFunction,
      },
    ],
  });
  setTableConfig(tableConfig);

  return (
    <Card>
      <Card.Header className="d-flex align-items-center justify-content-between ps-3 bg-white">
        <span>{t(modelConfig.modelPluralName)}</span>
        <div>
          <BeelditTableHeaderActions
            actions={tableConfig.actions}
          ></BeelditTableHeaderActions>
        </div>
      </Card.Header>

      <Card.Body>
        <div
          style={{
            display: !creationShowModal && !editShowModal ? "block" : "none",
          }}
        >
          {listActionTemplate}
        </div>
        {createActionTemplate}
        {editActionTemplate}
        {removeActionTemplate}
        {cancelActionTemplate}
        {uncancelActionTemplate}

        {/* newTemplateActions */}
      </Card.Body>
    </Card>
  );
}

export default CalendarPage;
